import styles from './styles.module.scss'

export function Maintenance() {
  return (
    <div className={styles.container}>
      <img src="/assets/logo_header.png" alt="Sortelec" />
      <h1>Estamos melhorando o produto. Voltaremos em breve.</h1>
    </div>
  )
}
